import React from 'react';
import {
  Container,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Typography,
  Box,
} from '@mui/material';
import valdeci from '../assets/valdeci.jpg';
import flavio from '../assets/flavio.png';

function Management() {
  const managementTeam = [
    {
      name: 'Valdeci Alves Diniz',
      role: 'Gestor',
      image: valdeci
    },
    {
      name: 'Gessica Dayanne',
      role: 'Coordenadora Pedagógica',
      image: '/images/management/vice-diretor.jpg'
    },
    {
      name: 'Flavio dos Anjos',
      role: 'CAF',
      image: flavio
    }
  ];

  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      <Typography variant="h3" component="h1" align="center" gutterBottom>
        Gestão
      </Typography>
      <Grid container spacing={4} justifyContent="center">
        {managementTeam.map((member, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
              <CardMedia
                component="img"
                sx={{
                  height: 400,
                  objectFit: 'cover',
                  transition: 'transform 0.3s ease-in-out',
                  '&:hover': {
                    transform: 'scale(1.02)',
                  },
                }}
                image={member.image}
                alt={member.name}
              />
              <CardContent sx={{ textAlign: 'center', bgcolor: 'primary.main', color: 'white' }}>
                <Typography variant="h5" component="h2" gutterBottom align="center">
                  {member.name}
                </Typography>
                <Typography variant="subtitle1" color="text.secondary" align="center">
                  {member.role}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}

export default Management;
